import { WEAPON_ICON_MAP } from "./constants";

/**
 * Get weapon icon URL from weapon name
 */
export const getWeaponIconUrl = (weapon: string): string => {
  if (!weapon) return "";
  // Normalize: lowercase and trim
  const normalized = weapon.toLowerCase().trim();
  // Look up in map, fallback to normalized name with spaces removed
  const iconName =
    WEAPON_ICON_MAP[normalized] || normalized.replace(/[\s-]/g, "");
  return `https://media.allstar.gg/static/web/cs2_icons/equipment/${iconName}.svg`;
};

/**
 * Convert tick to time string (M:SS format)
 */
export const tickToTimeString = (tick: number, tickRate: number): string => {
  const seconds = tick / tickRate;
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${minutes}:${secs.toString().padStart(2, "0")}`;
};

/**
 * Parse time string (M:SS format) to tick
 */
export const timeStringToTick = (
  timeStr: string,
  tickRate: number,
): number | null => {
  const match = timeStr.match(/^(\d+):(\d{2})$/);
  if (!match) return null;
  const minutes = parseInt(match[1], 10);
  const seconds = parseInt(match[2], 10);
  if (seconds >= 60) return null;
  return (minutes * 60 + seconds) * tickRate;
};

/**
 * Generate a unique ID
 */
export const generateId = (): string => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * Check if a team string represents CT
 */
export const isCTTeam = (team: string): boolean => {
  return (
    team === "CounterTerrorists" ||
    team === "CT" ||
    team?.toLowerCase().includes("counter")
  );
};

/**
 * Clean player name by removing special prefixes
 */
export const cleanPlayerName = (name: string): string => {
  return name.replace(/^[⑧⑨⑩⑪⑫⑬]\s*[✓★☆]*\s*/, "").trim();
};
